import React, { Component } from 'react'
import PropTypes from 'prop-types'
import './Icon.scss'

export default class Icon extends Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    className: PropTypes.string
  }

  render () {
    const { name } = this.props
    const icon = `/assets/img/icon-${name}.svg`

    return (
      <img className='accountLinkIcon' src={icon} alt='Login icon' />
    )
  }
}
